// generated by genversion
export var version = '4.1.3';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-amplify/core/lib-esm/Platform/version.js
// module id = 1626
// module chunks = 0